import React, { useEffect, useState } from 'react';
import { Alert, Badge, Button, Grid, Group, Paper, Stack, Text, Title } from '@mantine/core';
import { IconArrowRight, IconBolt, IconInfoCircle, IconLink, IconLock, IconShieldCheck } from '@tabler/icons-react';
import FileUploader from '../../components/FileShare/FileUploader';
import ShareOptions from '../../components/FileShare/ShareOptions';
import ShareSuccessModal from '../../components/FileShare/ShareSuccessModal';
import { useFileShare } from '../../components/FileShare/FileShareContext';
import { totalSize, formatBytes } from '../../components/FileShare/service/fileShareApi';
export default function NewSharePage() {
  const { createShare, settings, error: loadError } = useFileShare();
  const [files, setFiles] = useState([]);
  const [form, setForm] = useState({ title: '', note: '', days: String(settings.defaultDays), customDate: '', hasPassword: false, password: '', passwordConfirm: '', downloadLimit: '' });
  const [errors, setErrors] = useState({});
  const [busy, setBusy] = useState(false);
  const [created, setCreated] = useState(null);
  const [createdPassword, setCreatedPassword] = useState('');
  const [submissionError, setSubmissionError] = useState('');
  const [uploadProgress, setUploadProgress] = useState(null);

  // API ayarları geldikten sonra varsayılan süreyi forma aktar.
  useEffect(() => {
    setForm((prev) => prev.days === '7' ? { ...prev, days: String(settings.defaultDays) } : prev);
  }, [settings.defaultDays]);

  const submit = async (event) => {
    event.preventDefault();
    setSubmissionError('');
    setUploadProgress(null);
    const nextErrors = {};
    if (form.hasPassword) {
      if (!settings.allowPasswords) nextErrors.password = 'Şifreli paylaşım bu sistemde devre dışı bırakılmış.';
      else if (form.password.length < 8) nextErrors.password = 'Şifre en az 8 karakter olmalıdır.';
      if (form.password !== form.passwordConfirm) nextErrors.passwordConfirm = 'Girdiğiniz şifreler eşleşmiyor.';
    }
    if (form.days === 'custom' && !form.customDate) nextErrors.customDate = 'Bir geçerlilik tarihi seçin.';
    if (!files.length) nextErrors.files = 'Bağlantı oluşturmak için dosya seçin.';
    if (form.days === 'custom') {
      const limit = new Date(Date.now() + settings.maxDays * 86_400_000);
      const chosen = new Date(`${form.customDate}T23:59:59`);
      if (chosen <= new Date() || chosen > new Date(limit.getTime() + 86_400_000)) nextErrors.customDate = `Bugünden sonraki ${settings.maxDays} gün içinde tarih seçin.`;
    }
    setErrors(nextErrors);
    if (Object.keys(nextErrors).length) return;
    try {
      setBusy(true);
      const share = await createShare({
        files, title: form.title, note: form.note,
        days: form.days === 'custom' ? null : Number(form.days),
        customDate: form.days === 'custom' ? form.customDate : null,
        password: form.hasPassword ? form.password : '', downloadLimit: form.downloadLimit,
        onUploadProgress: (event) => {
          if (event.total) setUploadProgress(Math.min(100, Math.round(event.loaded * 100 / event.total)));
        },
      });
      setUploadProgress(100);
      setCreated(share);
      setCreatedPassword(form.hasPassword ? form.password : '');
      setFiles([]);
      setForm({ title: '', note: '', days: String(settings.defaultDays), customDate: '', hasPassword: false, password: '', passwordConfirm: '', downloadLimit: '' });
    } catch (error) {
      setSubmissionError(error?.message || 'Bağlantı oluşturulamadı.');
    } finally { setBusy(false); }
  };

  return <>
    <form onSubmit={submit}><Grid gutter="xl" align="start">
      <Grid.Col span={{ base: 12, lg: 7 }}><Paper className="fs-panel" p="lg">
        <Group justify="space-between" mb="lg"><div><Title order={3} size="lg">Dosyalar</Title><Text size="sm" c="dimmed">Paylaşmak istediğiniz dosyaları seçin.</Text></div></Group>
        <FileUploader files={files} onChange={setFiles} maxFileSizeMb={settings.maxFileSizeMb} maxShareSizeMb={settings.maxShareSizeMb} disabled={busy} uploadProgress={uploadProgress}/>
        {errors.files && <Alert mt="sm" color="red" icon={<IconInfoCircle size={17}/>}>{errors.files}</Alert>}
      </Paper></Grid.Col>
      <Grid.Col span={{ base: 12, lg: 5 }}><Stack gap="md"><Paper className="fs-panel" p="lg"><Group justify="space-between" mb="lg"><div><Title order={3} size="lg">Paylaşım Ayarları</Title><Text size="sm" c="dimmed">Bağlantının kurallarını tanımlayın.</Text></div></Group><ShareOptions form={form} setForm={setForm} settings={settings} errors={errors}/></Paper>
        <Paper className="fs-panel" p="lg"><Group justify="space-between" mb="md"><Text fw={750} size="sm">Özet</Text><IconShieldCheck color="#4167f4" size={20}/></Group><div className="fs-summary-row"><Text c="dimmed" size="sm">Dosya sayısı</Text><Text fw={750} size="sm">{files.length}</Text></div><div className="fs-summary-row"><Text c="dimmed" size="sm">Toplam boyut</Text><Text fw={750} size="sm">{formatBytes(totalSize(files))}</Text></div><div className="fs-summary-row"><Text c="dimmed" size="sm">Geçerlilik</Text><Text fw={750} size="sm">{form.days === 'custom' ? (form.customDate || 'Özel tarih') : `${form.days} gün`}</Text></div><div className="fs-summary-row"><Text c="dimmed" size="sm">Parola</Text><Text fw={750} size="sm">{form.hasPassword ? 'Etkin' : 'Kapalı'}</Text></div>
          {loadError && <Alert color="orange" mt="md">API ayarları yüklenemedi: {loadError}</Alert>}
          {submissionError && <Alert mt="md" color="red" icon={<IconInfoCircle size={18}/>}>{submissionError}</Alert>}
          <Button type="submit" mt="lg" fullWidth size="md" loading={busy} rightSection={<IconArrowRight size={18}/>}>Paylaşım Linki Oluştur</Button>
          <Text c="dimmed" size="xs" mt="md" ta="center">Dosyalar sunucuya yüklenir. Büyük dosyalarda işlem bitene kadar sayfayı kapatmayın.</Text>
        </Paper></Stack></Grid.Col>
      </Grid></form>
    <ShareSuccessModal share={created} password={createdPassword} onClose={() => { setCreated(null); setCreatedPassword(''); }}/>
  </>;
}
